// extracted by mini-css-extract-plugin
export var articleContainer = "style-module--articleContainer--fac46";
export var list = "style-module--list--a0680";